module.exports = __webpack_public_path__ + "img/tr.caf48056.svg";